/**
 * An agent's reply as a person reads it (docs/refactor/41, A9): the internal `DEVPULSE-STATUS:` line never shows —
 * it becomes "needs you" with the reason — and the lines the app and the server write in English (for the agents
 * and the log) are said in the person's language. One place, used by the prompt dock and by Comandos de fora.
 */

export type Translate = (key: string, vars?: Record<string, string | number>) => string

/** The lines the app writes in English, said in the person's language. */
export function saidInYourLanguage(line: string, t: Translate): string {
  return line
    .replace(/^The agent was stopped\.$/gim, t('dock.reply.stopped'))
    .replace(/^Stopped by the person\.$/gim, t('dock.reply.stoppedByYou'))
    .replace(/^The agent exited with code (-?\d+)\.$/gim, (_, code: string) => t('dock.reply.exited', { code }))
    .replace(/^\(no output\)$/gim, t('dock.reply.noOutput'))
    .replace(/^the agent was stopped before finishing$|^stopped before it finished$/gim, t('dock.reply.stoppedReason'))
    .replace(/^the agent exited with code (-?\d+) before finishing$/gim, (_, code: string) => t('dock.reply.exitedReason', { code }))
}

/** The reply split into what to show and what still needs the person, with no internal line left. */
export function readableReply(text: string, t: Translate): { body: string; pending: string | null } {
  const pending = /DEVPULSE-STATUS:\s*PENDING\s*(?:[—-]\s*)?(.*)/i.exec(text)
  const body = saidInYourLanguage(text.replace(/\n?DEVPULSE-STATUS:.*$/gim, '').trim(), t)
  const reason = pending ? saidInYourLanguage(pending[1]!.trim(), t) : null
  return { body, pending: pending ? (reason || t('dock.needsYouAny')) : null }
}
